import React from "react";
import ReactDOM from "react-dom";
import OutputReportsForUser from "../../components/OutputReportAdmin/OutputReportsForUser";

const addOutputReportsForUser = (api) => {
    // Detect if we're on Profile.aspx
    const partyId = document.getElementById("PersonIDHiddenField")?.value;
    const outputReportsDiv = document.getElementById("OutputReports");

    if (partyId && outputReportsDiv) {
        try {
            ReactDOM.render(
                <React.StrictMode>
                    <OutputReportsForUser api={api} partyId={partyId} />
                </React.StrictMode>,
                outputReportsDiv
            );
        } catch (e) {
            console.error("Failed to render OutputReportsForUser:", e);
        }
    }
};

export default addOutputReportsForUser;
